import React, { useState, useEffect } from 'react';

const ToastContainer = () => {
    const [toasts, setToasts] = useState([]);

    useEffect(() => {
        // Exposer la fonction showToast globalement
        window.showToast = (message, type = 'info') => {
            const id = Date.now();
            const newToast = { id, message, type };
            
            setToasts(prev => [...prev, newToast]);
            
            // Auto-suppression après 4 secondes
            setTimeout(() => {
                setToasts(prev => prev.filter(toast => toast.id !== id));
            }, 4000);
        };

        return () => {
            delete window.showToast;
        };
    }, []);

    const removeToast = (id) => {
        setToasts(prev => prev.filter(toast => toast.id !== id));
    };

    const getToastColor = (type) => {
        switch (type) {
            case 'success': return { bg: '#d4edda', border: '#c3e6cb', text: '#155724' };
            case 'error': return { bg: '#f8d7da', border: '#f5c6cb', text: '#721c24' };
            case 'warning': return { bg: '#fff3cd', border: '#ffeaa7', text: '#856404' };
            default: return { bg: '#d1ecf1', border: '#bee5eb', text: '#0c5460' };
        }
    };

    if (toasts.length === 0) return null;

    return (
        <div style={{
            position: 'fixed',
            top: '20px',
            right: '20px',
            zIndex: 9999,
            display: 'flex',
            flexDirection: 'column',
            gap: '10px',
        }}>
            {toasts.map(toast => {
                const colors = getToastColor(toast.type);
                return (
                    <div
                        key={toast.id}
                        style={{
                            backgroundColor: colors.bg,
                            border: `1px solid ${colors.border}`,
                            color: colors.text,
                            padding: '12px 16px',
                            borderRadius: '4px',
                            minWidth: '300px',
                            maxWidth: '500px',
                            boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            animation: 'slideIn 0.3s ease-out',
                        }}
                    >
                        <span style={{ fontSize: '14px' }}>{toast.message}</span>
                        <button
                            onClick={() => removeToast(toast.id)}
                            style={{
                                background: 'none',
                                border: 'none',
                                color: colors.text,
                                cursor: 'pointer',
                                fontSize: '16px',
                                marginLeft: '10px',
                                opacity: 0.7,
                            }}
                            onMouseEnter={(e) => e.target.style.opacity = 1}
                            onMouseLeave={(e) => e.target.style.opacity = 0.7}
                        >
                            ✕
                        </button>
                    </div>
                );
            })}
            <style>{`
                @keyframes slideIn {
                    from {
                        transform: translateX(100%);
                        opacity: 0;
                    }
                    to {
                        transform: translateX(0);
                        opacity: 1;
                    }
                }
            `}</style>
        </div>
    );
};

export default ToastContainer;
